"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  ", ": ", ";\n  ", "\n  ", "\n  ", "\n"], ["\n  ", ": ", ";\n  ", "\n  ", "\n  ", "\n"]);

var _breakpoints = require("./breakpoints");

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _styledComponents = require("styled-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var responsive = function responsive(field, xl, lg, md, sm) {
  return (0, _styledComponents.css)(_templateObject, field, xl, xl !== lg && "\n  @media(max-width: " + (_breakpoints2.default.lg + "px") + ") {\n    " + field + ": " + lg + ";\n  }\n  ", lg !== md && "\n  @media(max-width: " + (_breakpoints2.default.md + "px") + ") {\n    " + field + ": " + md + ";\n  }\n  ", md !== sm && "\n  @media(max-width: " + (_breakpoints2.default.sm + "px") + ") {\n    " + field + ": " + sm + ";\n  }\n  ");
};

exports.default = responsive;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-theme/dist/responsive.js
// module id = 235
// module chunks = 168707334958949